import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from './store/index'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  routes: [
    {
      path: "/",
      redirect: "inicio",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "Dashboard",
          path: "inicio",
          component: () => import("@/components/Monitor/Monitores"),
        },
        {
          name: "Contratos",
          path: "contratos",
          component: () => import("@/components/Contrato/Lista"),
        },
        {
          name: "Inmuebles",
          path: "inmuebles",
          component: () => import("@/components/Inmueble/Lista"),
        },
        {
          name: "Propietarios",
          path: "propietarios",
          component: () => import("@/components/Propietario/Lista"),
        },
        {
          name: "Inquilinos",
          path: "inquilinos",
          component: () => import("@/components/Inquilino/Lista"),
        },
        {
          name: "Usuarios",
          path: "usuarios",
          component: () => import("@/components/Users/Usuario"),
        },
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/layouts/full-layout/Login")
    },
    {
      path: "/firmar/:token",
      name: "FirmarPublico",
      component: () => import("@/components/Firma/FirmarPublico"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/compartido/:token",
      name: "VerCompartido",
      component: () => import("@/components/Contrato/VerCompartido"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/validar",
      name: "ValidarNom151",
      component: () => import("@/components/Validacion/ValidarNom151"),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "*",
      component: () => import("@/layouts/full-layout/NotFound"),
      meta: {
        requiresAuth: false
      }
    }
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  NProgress.start(800);

  store.commit(
    "setRouterHistory",
    from
  );

  if (to.matched.some(record => record.meta.requiresAdminAuth)) {
    if (store.getters.getInfoUser && store.getters.getInfoUser.admin) {
      next();
      return;
    }
    next('/')
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.commit(
      "setRouteData",
      {requireAuth: true}
    );
    if (store.getters.getLoginStatus) {
      next();
      return
    }
    next('/login')
  } else {
    store.commit(
      "setRouteData",
      {requireAuth: false}
    );
    next()
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
